export default __webpack_public_path__ + "static/media/au-torres_strait_islands.03d15572.svg";